import React, { useState, useEffect } from 'react';
import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Select } from 'antd';

interface ReviewSearchSortProps {
    sortBy: string;
    onSortChange: (value: string) => void;
    onSearch: (value: string) => void;
    initialSearchText?: string;
}

export const ReviewSearchSort: React.FC<ReviewSearchSortProps> = ({ sortBy, onSortChange, onSearch, initialSearchText = '' }) => {
    const [searchText, setSearchText] = useState(initialSearchText);

    useEffect(() => {
        setSearchText(initialSearchText);
    }, [initialSearchText]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSearchText(value);
        onSearch(value);
    };

    const handleClear = () => {
        setSearchText('');
        onSearch('');
    };

    return (
        <div className="search-sort-container">
            <div className="activity-search-wrapper">
                <SearchOutlined className="search-icon" />
                <input
                    type="text"
                    placeholder="Search reviews (e.g. guide)"
                    value={searchText}
                    onChange={handleChange}
                />
                {searchText && (
                    <CloseCircleOutlined className="clear-icon" onClick={handleClear} />
                )}
            </div>
            <div className="sort-wrapper">
                <Select
                    value={sortBy}
                    onChange={(value) => onSortChange(value)}
                    style={{ width: 180 }}
                    className="review-sort-select"
                >
                    <Select.Option value="MOST_RECENT">Sort by: Most recent</Select.Option>
                    <Select.Option value="MOST_HELPFUL">Sort by: Most helpful</Select.Option>
                    <Select.Option value="HIGHEST_RATING">Sort by: Highest rating</Select.Option>
                </Select>
            </div>
        </div>
    );
};
